import React from 'react'
import "./PillButton.css"

interface PillButtonProps {
  value: string
  capitalize?: boolean
  onClick?: (e: React.SyntheticEvent) => void
  ariaLabel: string
}

const PillButton = ({
                  value,
                  onClick,
                  capitalize,
                  ariaLabel
                }: PillButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={`spacing-bottom--medium pill-button ${capitalize ? 'pill-button--capitalize ' : ''}`}
      type="button"
      aria-label={ariaLabel}
    >
      <span>
        {value}
      </span>
    </button>
  )
}

export default PillButton